// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1xoOO","topBottomGutter":"Layout_topBottomGutter__1Nwgk"};